export default __webpack_public_path__ + "static/media/dynamic_value_editor.0e0080ad.png";